var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardStats2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03293 10L20.9671 10C21.9872 10 22.3878 8.64858 21.539 8.07059L13.1438 2.35375C12.4512 1.88208 11.5488 1.88208 10.8562 2.35375L2.46102 8.07059C1.61224 8.64858 2.01282 10 3.03293 10Z",
    stroke: "#28303F",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 5,
    height: 8,
    stroke: "#28303F",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 5,
    height: 8,
    stroke: "#28303F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.382 18C19.7607 18 20.107 18.214 20.2764 18.5528L21.2764 20.5528C21.6088 21.2177 21.1253 22 20.382 22L3.61803 22C2.87465 22 2.39116 21.2177 2.72361 20.5528L3.72361 18.5528C3.893 18.214 4.23926 18 4.61803 18L19.382 18Z",
    stroke: "#28303F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardStats2);
export default __webpack_public_path__ + "static/media/dashboard-stats-2.14d073c13f54848ae9fe799e820b87f5.svg";
export { ForwardRef as ReactComponent };